import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'alg-pre-consent',
  templateUrl: './alg-pre-consent.component.html',
  styleUrls: ['./alg-pre-consent.component.scss'],
})
export class AlgPreConsentComponent implements OnInit {
  @Output() onClick = new EventEmitter<boolean>();

  constructor(private route: ActivatedRoute, private router: Router) {}

  nextPage: string;

  ngOnInit() {
    this.route.data.subscribe((data) => {
      this.nextPage = data['nextPage'];
    });
  }

  handleClick() {
    this.onClick.emit(true);
  }

  moveToNextPage() {
    // To add a layer of security this page adds a queryParam "hash"
    // This params is simply the next page path encoded with base64 (and made URI safe)
    // [ConsensoGuard] is gonna challenge the incoming hash with url it's gonna be guarding

    // Get next page tree -> url
    const nextRouteTree = this.router.createUrlTree([this.nextPage], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
    });
    const serializedNextRouteUrl = this.router.serializeUrl(nextRouteTree);

    // Encode url in base64 -> encodeUri
    const b64Hash = btoa(serializedNextRouteUrl);
    const encodedHash = encodeURIComponent(b64Hash);

    this.router.navigate([this.nextPage], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
      queryParams: {
        hash: encodedHash,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-pre-consent/alg-pre-consent.component.ts